import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { FormattedMessage } from 'react-intl';

import Modal from '../../../../components/modal';
import messages from '../../../../text/messages';
import WizardButtons from '../../../../components/wizard/navigator/buttons';
import { DateField, TextField, TextAreaField, SelectField } from '../../../../components/fields';
import { getCurrencySymbol } from '../../../../utilities/string';
import { number, required, isValidDateTime } from '../../../../utilities/validation';
import { ConfirmationDialog } from '../../../../components/dialogs';

class AddSoW extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            confirmationModal: false
        };

        this.handleModal = this.handleModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeConfirmationModal = this.closeConfirmationModal.bind(this);
        this.openConfirmationModal = this.openConfirmationModal.bind(this);
        this.isEdit = this.isEdit.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.getButtonText = this.getButtonText.bind(this);
        this.save = this.save.bind(this);
        this.remove = this.remove.bind(this);
    }

    handleModal() {
        this.setState({ modal: true });
    }

    closeModal() {
        this.setState({ modal: false });
    }

    save(values) {
        const { onSubmit, initialValues, reset } = this.props;
        onSubmit({ ...initialValues, ...values });
        reset();
        this.closeModal();
    }

    remove() {
        const { onRemove, initialValues } = this.props;
        onRemove(initialValues.id);
        this.closeModal();
    }

    getTitle() {
        const { billingType, initialValues } = this.props;

        if (initialValues) {
            return { expense: messages.editExpenseTitle, deliverable: messages.editDeliverableTitle }[billingType] || messages.emptyMessage;
        }

        return { expense: messages.addExpenseTitle, deliverable: messages.addDeliverableTitle }[billingType] || messages.emptyMessage;
    }

    isEdit() {
        const { initialValues } = this.props;
        return !!(initialValues && initialValues.amount);
    }

    getButtonText() {
        const { billingType } = this.props;

        if (this.isEdit()) {
            return messages.edit;
        }
        return { expense: messages.addExpense, deliverable: messages.addDeliverable }[billingType] || messages.emptyMessage;
    }

    closeConfirmationModal() {
        this.setState({ confirmationModal: false });
    }
    openConfirmationModal() {
        this.setState({ confirmationModal: true });
    }

    render() {
        const { modal, confirmationModal } = this.state;
        const { handleSubmit, submitting, currency, projectsOptions } = this.props;
        let { initialValues } = this.props;

        return (
            <div>
                <span onClick={this.handleModal} className={`button ${this.isEdit() ? 'edit' : ''}`}>
                    <FormattedMessage {...this.getButtonText()} />
                </span>

                <Modal open={modal} onClose={this.closeModal} size="col-sm-6 col-sm-offset-3 col-xs-12" title={<FormattedMessage {...this.getTitle()} />}>
                    <div>
                        <div className="close-modal" onClick={this.closeModal}>
                            <i className="material-icons">clear</i>
                        </div>

                        <div className="row">
                            <div className="col-xs-12">
                                <form onSubmit={handleSubmit(this.save)}>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <Field
                                                name="project_id"
                                                validate={required}
                                                component={SelectField}
                                                options={projectsOptions}
                                                placeholder={messages.project}
                                                disabled={projectsOptions.length < 2}
                                            />
                                        </div>
                                        <div className="col-sm-6 col-xs-12">
                                            <Field name="date" component={DateField} validate={[required, isValidDateTime]} placeholder={messages.date} />
                                        </div>

                                        <div className="col-sm-6 col-xs-12">
                                            <Field
                                                name="amount"
                                                validate={[required, number]}
                                                component={TextField}
                                                extras={{ left: getCurrencySymbol(currency) }}
                                                placeholder={messages.amount}
                                            />
                                        </div>
                                        <div className="col-xs-12">
                                            <Field
                                                name={'description'}
                                                component={TextAreaField}
                                                validate={[required]}
                                                placeholder={messages.detailedDescription}
                                            />
                                        </div>
                                    </div>

                                    <ConfirmationDialog
                                        modal={{ open: confirmationModal }}
                                        onSubmit={() => null}
                                        onClose={this.closeConfirmationModal}
                                        message={<FormattedMessage {...messages.removeDeliverableConfirmation} />}
                                        save={{ message: <FormattedMessage {...messages.confirm} />, action: this.remove }}
                                    />

                                    <WizardButtons
                                        disabled={submitting}
                                        reject={{
                                            show: !!initialValues,
                                            action: this.openConfirmationModal,
                                            message: <FormattedMessage {...messages.remove} />
                                        }}
                                        back={{ action: this.closeModal, message: <FormattedMessage {...messages.cancel} /> }}
                                        submit={{ message: <FormattedMessage {...messages.confirm} /> }}
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

AddSoW = reduxForm({
    destroyOnUnmount: false,
    enableReinitialize: true,
    forceUnregisterOnUnmount: true
})(AddSoW);

const mapStateToProps = (state, props) => {
    const currency = props.projects[0].job_project.rate_currency;
    const dateField = props.billingType === 'expense' ? 'expense_date' : 'date';
    return {
        currency,
        form: `billing-${props.initialValues ? props.initialValues.id : 'new'}`,
        initialValues: props.initialValues
            ? {
                  ...props.initialValues,
                  ...{ date: moment.tz(props.initialValues[dateField], props.job.work_timezone) }
              }
            : {
                  project_id: props && props.projects && props.projectsOptions[0].value,
                  currency
              }
    };
};

export default connect(mapStateToProps, null)(AddSoW);



// WEBPACK FOOTER //
// ./src/pages/timekeeping/components/billings/addBilling.jsx